module.exports = __webpack_public_path__ + "img/语音.4ed18cf2.png";